
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/investing/credit",
      function () {
        return require("private-next-pages/investing/credit/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/investing/credit"])
      });
    }
  